import Footer from "~/components/Footer";
import Header from "~/components/Header";
const TermsOfService = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow pt-20">
        <div className="max-w-4xl mx-auto px-4 py-8 font-sans">
          <h1 className="text-3xl font-bold text-gray-900 border-b-2 border-gray-200 pb-4 mb-8">
            Terms of Service for Cloud Exam Hub
          </h1>

          <p className="text-gray-600 italic mb-8">
            Last Updated: October 30, 2024
          </p>

          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-8">
            <p className="text-gray-800 font-bold">
              PLEASE READ THESE TERMS OF SERVICE CAREFULLY. THEY CONTAIN
              IMPORTANT INFORMATION ABOUT YOUR LEGAL RIGHTS, REMEDIES, AND
              OBLIGATIONS. BY USING CLOUD EXAM HUB, YOU AGREE TO THESE TERMS AND
              CONDITIONS.
            </p>
          </div>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              1. Introduction and Acceptance
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>
                Cloud Exam Hub is a product offering of Square Zero Labs LLC.
                These Terms of Service (&quot;Terms&quot;) constitute a legally
                binding agreement between you and Square Zero Labs LLC
                (&quot;we,&quot; &quot;our,&quot; or &quot;us&quot;) governing
                your use of our practice test platform, website, and services
                (collectively, the &quot;Services&quot;).
              </p>
              <p>By accessing or using the Services, you represent that you:</p>
              <ul className="list-disc pl-5 space-y-2">
                <li>Are at least 18 years old</li>
                <li>Have the legal capacity to enter into these Terms</li>
                <li>Agree to be bound by these Terms</li>
                <li>Will comply with all applicable laws and regulations</li>
              </ul>
              <p>
                If you do not agree to these Terms, do not use our Services.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              2. Service Description
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>
                Cloud Exam Hub provides practice tests to help users prepare for
                AWS certification exams. Our Services are for practice and
                preparation only and are not affiliated with, endorsed by, or
                connected to Amazon Web Services (AWS).
              </p>
              <p>We reserve the right to:</p>
              <ul className="list-disc pl-5 space-y-2">
                <li>
                  Modify or discontinue any aspect of our Services at any time
                </li>
                <li>Restrict access to any features</li>
                <li>Limit availability to any geographic areas</li>
                <li>Impose usage or service limits</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              3. Account Registration and Security
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>
                You must register an account to access most features. You agree
                to:
              </p>
              <ul className="list-disc pl-5 space-y-2">
                <li>Provide accurate and complete information</li>
                <li>Maintain and update your information</li>
                <li>Keep your password confidential</li>
                <li>Not share your account credentials</li>
                <li>Notify us immediately of any unauthorized access</li>
              </ul>
              <p>
                You are solely responsible for all activity that occurs under
                your account.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              4. Intellectual Property Rights
            </h2>
            <div className="space-y-4 text-gray-700">
              <p className="font-semibold">
                ALL CONTENT IS PROTECTED BY COPYRIGHT AND OTHER INTELLECTUAL
                PROPERTY RIGHTS.
              </p>
              <p>You may not:</p>
              <ul className="list-disc pl-5 space-y-2">
                <li>Copy, distribute, or share test questions or answers</li>
                <li>Create derivative works from our content</li>
                <li>Use our content for training others</li>
                <li>
                  Attempt to circumvent any technological protection measures
                </li>
                <li>Use automated systems, bots, scrapers, or crawlers</li>
                <li>Reverse engineer or decompile any part of our platform</li>
                <li>Take screenshots or photos of test questions</li>
                <li>Store or record test content in any manner</li>
                <li>Share access to your account or test materials</li>
              </ul>
              <p className="font-semibold">
                VIOLATIONS WILL RESULT IN IMMEDIATE ACCOUNT TERMINATION AND
                POSSIBLE LEGAL ACTION.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              5. Money Back Guarantee
            </h2>
            <p className="text-gray-700 mb-4">
              We offer a 14-day money back guarantee if you are unsatisfied with
              our service. To qualify:
            </p>
            <ul className="list-disc pl-5 space-y-2 text-gray-700">
              <li>Your account must be in good standing</li>
              <li>You must have completed fewer than 3 practice tests</li>
              <li>You must request the refund within 14 days of purchase</li>
              <li>Refund applies to your most recent purchase only</li>
              <li>No refunds if any terms of service violations occurred</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              6. Disclaimers and Warranty Limitations
            </h2>
            <div className="bg-gray-50 p-4 border border-gray-300 rounded-lg">
              <p className="font-bold text-gray-900 mb-4">
                PLEASE READ THIS SECTION CAREFULLY. IT LIMITS OUR LIABILITY AND
                DISCLAIMS WARRANTIES.
              </p>

              <div className="space-y-4 text-gray-700">
                <p className="uppercase font-semibold">
                  TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW:
                </p>

                <p>
                  THE SERVICES AND ALL CONTENT ARE PROVIDED &quot;AS IS,&quot;
                  &quot;AS AVAILABLE,&quot; AND &quot;WITH ALL FAULTS&quot;
                  WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESS OR IMPLIED. CLOUD
                  EXAM HUB ACTIVELY DISCLAIMS ALL WARRANTIES AND CONDITIONS,
                  INCLUDING IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
                  PARTICULAR PURPOSE, TITLE, NON-INFRINGEMENT, QUIET ENJOYMENT,
                  AND WARRANTIES ARISING FROM COURSE OF DEALING OR USAGE OF
                  TRADE.
                </p>

                <p>
                  WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY,
                  RELIABILITY, COMPLETENESS, OR TIMELINESS OF THE SERVICES OR
                  ANY CONTENT, INCLUDING BUT NOT LIMITED TO PRACTICE TEST
                  QUESTIONS, ANSWERS, EXPLANATIONS, OR STUDY MATERIALS.
                </p>

                <p>WE DO NOT WARRANT THAT:</p>
                <ul className="list-disc pl-5 space-y-2">
                  <li>
                    THE SERVICES WILL MEET YOUR REQUIREMENTS OR EXPECTATIONS
                  </li>
                  <li>
                    THE SERVICES WILL BE UNINTERRUPTED, TIMELY, SECURE, OR
                    ERROR-FREE
                  </li>
                  <li>
                    THE RESULTS FROM USING THE SERVICES WILL BE ACCURATE OR
                    RELIABLE
                  </li>
                  <li>ANY ERRORS IN THE SERVICES WILL BE CORRECTED</li>
                  <li>
                    THE SERVICES OR CONTENT WILL HELP YOU PASS ANY CERTIFICATION
                    EXAM
                  </li>
                  <li>THE SERVICES OR ANY CONTENT WILL REMAIN AVAILABLE</li>
                  <li>
                    THE QUALITY OF ANY PRODUCTS, SERVICES, INFORMATION, OR OTHER
                    MATERIAL WILL MEET YOUR EXPECTATIONS
                  </li>
                </ul>
                <p>YOU ACKNOWLEDGE AND UNDERSTAND:</p>
                <ul className="list-disc pl-5 space-y-2">
                  <li>
                    Our practice tests are not official AWS exam questions
                  </li>
                  <li>
                    Passing our practice tests does not guarantee you will pass
                    the actual AWS exam
                  </li>
                  <li>
                    We do not guarantee that our content covers all topics on
                    the actual exam
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              7. Limitation of Liability and Release
            </h2>
            <div className="bg-gray-50 p-4 border border-gray-300 rounded-lg">
              <p className="font-bold text-gray-900 mb-4">
                PLEASE READ THIS SECTION CAREFULLY. IT LIMITS THE LIABILITY OF
                CLOUD EXAM HUB AND ITS AFFILIATES.
              </p>

              <div className="space-y-4 text-gray-700">
                <p className="uppercase font-semibold">
                  TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW:
                </p>

                <p>
                  IN NO EVENT SHALL CLOUD EXAM HUB, ITS DIRECTORS, OFFICERS,
                  EMPLOYEES, AGENTS, PARTNERS, SUPPLIERS, CONTENT PROVIDERS,
                  SUCCESSORS, OR ASSIGNS BE LIABLE FOR ANY:
                </p>
                <ul className="list-disc pl-5 space-y-2">
                  <li>
                    INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, PUNITIVE, OR
                    EXEMPLARY DAMAGES
                  </li>
                  <li>
                    DAMAGES FOR LOSS OF PROFITS, GOODWILL, USE, DATA, OR OTHER
                    INTANGIBLE LOSSES
                  </li>
                  <li>
                    DAMAGES RELATING TO YOUR ACCESS TO, USE OF, OR INABILITY TO
                    ACCESS OR USE THE SERVICES
                  </li>
                  <li>
                    DAMAGES RELATING TO ANY CONDUCT OR CONTENT OF ANY THIRD
                    PARTY ON OR RELATED TO THE SERVICES
                  </li>
                  <li>
                    DAMAGES RELATING TO ANY CERTIFICATION EXAM RESULTS OR
                    OUTCOMES
                  </li>
                  <li>
                    DAMAGES RELATING TO ANY UNAUTHORIZED ACCESS TO OR USE OF OUR
                    SERVERS OR ANY PERSONAL INFORMATION
                  </li>
                  <li>
                    DAMAGES RELATING TO ANY INTERRUPTION OR CESSATION OF
                    TRANSMISSION TO OR FROM THE SERVICES
                  </li>
                  <li>
                    DAMAGES RELATING TO ANY BUGS, VIRUSES, TROJAN HORSES, OR THE
                    LIKE TRANSMITTED THROUGH THE SERVICES
                  </li>
                </ul>

                <p>
                  THIS LIMITATION APPLIES TO ALL CAUSES OF ACTION, WHETHER BASED
                  ON BREACH OF CONTRACT, BREACH OF WARRANTY, TORT (INCLUDING
                  NEGLIGENCE), PRODUCT LIABILITY, OR ANY OTHER LEGAL THEORY,
                  EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH
                  DAMAGES.
                </p>

                <p className="font-semibold mt-4">
                  IN ANY CASE, OUR AGGREGATE LIABILITY UNDER THESE TERMS SHALL
                  BE LIMITED TO THE AMOUNT YOU HAVE PAID US IN THE THREE (3)
                  MONTHS PRECEDING THE INCIDENT GIVING RISE TO THE CLAIM, OR ONE
                  HUNDRED DOLLARS ($100.00), WHICHEVER IS LESS.
                </p>

                <p>
                  SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF
                  CERTAIN DAMAGES, SO SOME OR ALL OF THE ABOVE EXCLUSIONS AND
                  LIMITATIONS MAY NOT APPLY TO YOU. IN SUCH CASES, OUR LIABILITY
                  WILL BE LIMITED TO THE FULLEST EXTENT PERMITTED BY APPLICABLE
                  LAW.
                </p>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              8. Acknowledgment and Assumption of Risk
            </h2>
            <div className="bg-gray-50 p-4 border border-gray-300 rounded-lg">
              <div className="space-y-4 text-gray-700">
                <p>
                  YOU EXPRESSLY AGREE THAT YOUR USE OF THE SERVICES IS AT YOUR
                  SOLE RISK. YOU ACKNOWLEDGE AND AGREE THAT:
                </p>
                <ul className="list-disc pl-5 space-y-2">
                  <li>
                    YOU ARE SOLELY RESPONSIBLE FOR YOUR EXAM PREPARATION AND
                    RESULTS
                  </li>
                  <li>
                    NO ADVICE OR INFORMATION OBTAINED THROUGH THE SERVICES SHALL
                    CREATE ANY WARRANTY NOT EXPRESSLY STATED IN THESE TERMS
                  </li>
                  <li>
                    YOU USE ANY MATERIAL OBTAINED THROUGH THE SERVICES AT YOUR
                    OWN DISCRETION AND RISK
                  </li>
                  <li>
                    YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR
                    COMPUTER SYSTEM OR LOSS OF DATA RESULTING FROM USE OF THE
                    SERVICES
                  </li>
                </ul>

                <p className="mt-4 font-semibold">
                  BY USING THE SERVICES, YOU KNOWINGLY AND EXPRESSLY RELEASE
                  CLOUD EXAM HUB FROM ANY AND ALL LIABILITY CONNECTED WITH YOUR
                  CERTIFICATION PURSUIT AND EXAM RESULTS. YOU ACKNOWLEDGE THAT
                  PASSING OR FAILING ANY CERTIFICATION EXAM IS DEPENDENT UPON
                  YOUR OWN SKILLS, EFFORT, AND PREPARATION.
                </p>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              9. Service Availability
            </h2>
            <ul className="list-disc pl-5 space-y-2 text-gray-700">
              <li>
                Our service may be unavailable at times for maintenance or
                updates
              </li>
              <li>We do not guarantee any specific level of uptime</li>
              <li>
                We are not liable for any:
                <ul className="list-circle pl-5 mt-2 space-y-2">
                  <li>Scheduled or unscheduled downtime</li>
                  <li>System failures</li>
                  <li>Data loss during outages</li>
                  <li>Technical problems</li>
                  <li>Network or server issues</li>
                </ul>
              </li>
              <li>No refunds or credits will be issued for downtime</li>
              <li>
                We reserve the right to modify or discontinue any feature at any
                time
              </li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              10. Account Security
            </h2>
            <p className="text-gray-700 mb-4">You are responsible for:</p>
            <ul className="list-disc pl-5 space-y-2 text-gray-700">
              <li>Maintaining the confidentiality of your account</li>
              <li>All activities that occur under your account</li>
              <li>Notifying us of any unauthorized use</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              11. Termination of your account
            </h2>
            <p className="text-gray-700 mb-4">
              We reserve the right to terminate or suspend your account for:
            </p>
            <ul className="list-disc pl-5 space-y-2 text-gray-700">
              <li>Violation of these terms</li>
              <li>Sharing account access</li>
              <li>Attempting to reverse engineer our tests</li>
              <li>Any fraudulent activity</li>
              <li>Any activity we deem harmful to our service</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              12. Payment and Access Terms
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>
                Cloud Exam Hub is offered for a one-time payment that grants
                access to our current practice test platform. You acknowledge
                and agree that:
              </p>
              <ul className="list-disc pl-5 space-y-2">
                <li>
                  Your payment provides access to the platform in its current
                  form
                </li>
                <li>
                  We do not guarantee any specific duration of service
                  availability
                </li>
                <li>
                  We are not obligated to provide updates or additional content
                </li>
                <li>
                  Content may be modified, removed, or updated at our discretion
                </li>
                <li>Refunds are available only as specified in these Terms</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              13. Service Termination
            </h2>
            <p>You acknowledge and agree that:</p>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                The Services are provided on an &quot;as available&quot; basis
              </li>
              <li>
                We reserve the right to discontinue the Services for business
                reasons
              </li>
              <li>
                We may cease operations due to business decisions, bankruptcy,
                or other reasons
              </li>
              <li>
                We will make commercially reasonable efforts to provide at least
                60 days&apos; notice before any planned complete termination of
                the service via email or website announcement
              </li>
              <li>
                Customers who purchased access within 60 days prior to the
                actual termination date will be eligible for a full refund
              </li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              14. Updates to Terms
            </h2>
            <p className="text-gray-700">
              We may update these terms at any time. Continued use of Cloud Exam
              Hub after changes means you accept the new terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              15. Governing Law
            </h2>
            <p className="text-gray-700 leading-relaxed">
              These terms are governed by the laws of the State of California,
              without regard to its conflict of law principles.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              16. Dispute Resolution
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Any dispute, claim, or controversy arising out of or relating to
              these terms or the use of Cloud Exam Hub services will be resolved
              exclusively in the state or federal courts of California in San
              Francisco County. Both parties agree to:
            </p>
            <ul className="list-disc pl-5 space-y-2 text-gray-700">
              <li>Submit to the personal jurisdiction of California courts</li>
              <li>Accept California as the exclusive forum for any disputes</li>
              <li>Waive any right to a jury trial</li>
              <li>Bring any claims within one (1) year of their accrual</li>
              <li>
                Participate in good faith in informal dispute resolution before
                filing any legal action
              </li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              17. Class Action Waiver
            </h2>
            <div className="bg-gray-50 p-4 border border-gray-300 rounded-lg text-gray-700">
              <p className="font-bold mb-4">
                BOTH PARTIES AGREE TO WAIVE ANY RIGHT TO PARTICIPATE IN A CLASS
                ACTION LAWSUIT OR CLASS-WIDE ARBITRATION.
              </p>
              <p>
                Any legal proceedings will be conducted solely on an individual
                basis. Neither you nor we may join or consolidate claims by or
                against other users, or litigate any claim as a representative
                or class member in any proceeding.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              18. Severability
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>
                If any provision of these Terms is found unenforceable, that
                provision will be severed. Remaining provisions remain in full
                force and effect. The unenforceable provision will be replaced
                with a valid provision that most closely matches the original
                intent.
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              19. Electronic Communications
            </h2>
            <p className="text-gray-700 leading-relaxed">
              By using our services, you consent to receive electronically all
              communications, agreements, and notices from us. We will provide
              these communications by posting them on our website or sending
              them to your registered email address. You may withdraw this
              consent by contacting us, but we reserve the right to terminate
              your account if you do so.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              20. Contact
            </h2>
            <p className="text-gray-700">
              Questions about these terms? Contact us at help@cloudexamhub.com
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfService;
